'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _userMessages = require('./user-messages.html');

var _userMessages2 = _interopRequireDefault(_userMessages);

var _userMessages3 = require('./user-messages.controller');

var _userMessages4 = _interopRequireDefault(_userMessages3);

require('./user-messages.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userMessagesComponent = {
  restrict: 'E',
  bindings: {
    userId: '<'
  },
  template: _userMessages2.default,
  controller: _userMessages4.default,
  controllerAs: 'vm'
};

exports.default = userMessagesComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-messages/user-messages.component.js
 **/